import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */

export const constantRoutes = [
  {
    path: '/',
    name: '首页',
    component: () => import('@/views/index'),
    meta: { title: '海那边-互联网海外移民房产保险综合服务平台领创者' }
  }
]

const createRouter = () => new Router({
  base:'/chuhai',
  mode: process.env.NODE_ENV === 'production' ? 'history' : 'hash', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router

